export const submitServiceConstraints = {
    name: { presence: { allowEmpty: false } },
    id: { presence: { allowEmpty: true } },
    shortDescription: { presence: { allowEmpty: false } },
    longDescription: { presence: { allowEmpty: false } },
    contributors: {
        presence: {
            allowEmpty: false,
            message: "^Please provide the contributors details of the service",
        },
    },
    tags: { presence: { allowEmpty: false, message: "^Please provide the tags for the service" } },
    "assets.heroImage.url": {
        presence: {
            allowEmpty: false,
            message: "^Please upload an image for the service",
        },
    },
    "assets.protoFiles.url": {
        presence: {
            allowEmpty: false,
            message: "^Please upload the proto file of the service",
        },
    },
    groups: {
        array: {
            name: { presence: { allowEmpty: false, message: "^Please enter group details" } },
            id: { presence: { allowEmpty: false, message: "^Please enter group details" } },
            testEndpoints: {
                validURL: { message: "Invalid Endpoint. Endpoint should start with Https" },
            },
            endpoints: { presence: { allowEmpty: false, message: "^Please enter group details" } },
            daemonAddresses: {
                presence: { allowEmpty: false, message: "^Please enter group details" },
            },
        },
    },
};

export const submitServiceBusicFields = {
    name: { presence: { allowEmpty: false } },
    id: { presence: { allowEmpty: true } },
    shortDescription: { presence: { allowEmpty: false } },
    longDescription: { presence: { allowEmpty: false } },
    contributors: {
        presence: {
            allowEmpty: false,
            message: "^Please provide the contributors details of the service",
        },
    },
    tags: { presence: { allowEmpty: false, message: "^Please provide the tags for the service" } },
    "assets.heroImage.url": {
        presence: {
            allowEmpty: false,
            message: "^Please upload an image for the service",
        },
    },
    "assets.protoFiles.url": {
        presence: {
            allowEmpty: false,
            message: "^Please upload the proto file of the service",
        },
    },
};

export const submitServiceGroups = {
    name: { presence: { allowEmpty: false, message: "^Please enter group name" } },
    endpoints: { presence: { allowEmpty: false, message: "^Please enter daemon endpoints" } },
    daemonAddresses: {
        presence: { allowEmpty: false, message: "^Please enter daemon addresses" },
    },
};
